import React, { useState, useEffect, useRef, useCallback } from "react";
import { incomeGridColumnLayOut } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import { useAxiosWithAuthorization } from "../../../utils/api";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import useAppContext from "../../../utils/Reducers";

const IncomeHistory = (props) => {
  const myGrid = useRef();

  const [initFields, setInitFields] = useState({
    schMonth: 1,
    schRvndrNm: props?.fieldValues?.rvndrNm,
    schVhclNo: props?.fieldValues?.vhclNo,
  });

  useEffect(() => {
    setInitFields({
      schMonth: 1,
      schRvndrNm: props?.fieldValues?.rvndrNm,
      schVhclNo: props?.fieldValues?.vhclNo,
    });
  }, [props?.fieldValues]);

  const SEARCH_INCOMEHOISTORY_URL =
    "/inspection/video/searchIncomeHistoryList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_INCOMEHOISTORY_URL,
    },
    { manual: true }
  );

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize(400, 680);
  }, [menuKey]);

  const handleSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();

    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_INCOMEHOISTORY_URL,
      params: {
        rvndrNm: initFields.schRvndrNm,
        vhclNo: initFields.schVhclNo,
        smonth: -initFields.schMonth,
      },
    });
    auiGrid.setGridData(data);

    auiGrid.removeAjaxLoader();
  };

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;

    setInitFields({ ...initFields, [name]: value });
  });

  return (
    <>
      <div className="table_list on">
        <div className="searchdata">
          <ul className="displays">
            <li style={{ width: "120px", paddingRight: "0px" }}>
              <div style={{ width: "50px" }}>조회조건</div>
              <select
                onChange={handleChangeField}
                name="schMonth"
                value={initFields.schMonth}
                style={{ width: "70px" }}
              >
                <option value={1}>1개월</option>
                <option value={3}>3개월</option>
                <option value={6}>6개월</option>
              </select>
            </li>
            <li style={{ width: "140px", paddingRight: "0px" }}>
              <div style={{ width: "60px" }}>차량번호</div>
              <input
                style={{ width: "80px" }}
                type="text"
                name="schVhclNo"
                onChange={handleChangeField}
                value={initFields.schVhclNo}
              />
            </li>
            <li style={{ width: "50px" }}>
              <button
                type="button"
                className="btn_orenge updown0"
                onClick={handleSearch}
              >
                검색
              </button>
            </li>
          </ul>
        </div>
        <div style={{ width: "100%", height: "100%" }}>
          <AUIGrid
            ref={myGrid}
            columnLayout={incomeGridColumnLayOut}
            gridProps={{ ...defaultGridProps, width: 400, height: 680 }}
          />
        </div>
      </div>
    </>
  );
};
export default IncomeHistory;
